import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Dialog,
  Grid,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { DeviceConfiguration } from "../../../cobra-backend-client";
import {
  CableControlModeEnum,
  getCableControlModeEnumValues,
  mapCableControlModeValueToLabel,
} from "../../../models/CableControlModeEnum";
import { CustomFab } from "../../common/CustomFab";
import { CustomImageRadio } from "../../common/CustomImageRadio";

interface Props {
  updatedDeviceConfiguration: DeviceConfiguration;
  setUpdatedDeiceConfiguration: React.Dispatch<
    React.SetStateAction<DeviceConfiguration>
  >;
}

const ControlBoxMode = (props: Props) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCableControlMode, setSelectedCableControlMode] =
    useState<CableControlModeEnum>();

  useEffect(() => {
    if (
      props.updatedDeviceConfiguration.cableControl?.cableControlMode != null
    ) {
      setSelectedCableControlMode(
        props.updatedDeviceConfiguration.cableControl?.cableControlMode
      );
    }
  }, [props.updatedDeviceConfiguration.cableControl?.cableControlMode]);

  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    const cableControlMode = +value as CableControlModeEnum;
    setSelectedCableControlMode(cableControlMode);

    const newDeviceConfiguration: DeviceConfiguration = {
      ...props.updatedDeviceConfiguration,
      cableControl: {
        ...props.updatedDeviceConfiguration.cableControl,
        cableControlMode: cableControlMode,
      },
    };

    props.setUpdatedDeiceConfiguration(newDeviceConfiguration);
  };

  return (
    <>
      <Grid
        item
        xs={6}
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          display: "flex",
        }}
      >
        <Typography>Control box mode </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        sx={{
          alignItems: "center",
          justifyContent: "flex-end",
          display: "flex",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Typography sx={{ pr: 1 }}>
            {mapCableControlModeValueToLabel(selectedCableControlMode)}
          </Typography>
          <Box>
            <CustomFab
              icon={<EditIcon />}
              onClick={() => setOpenDialog(true)}
            />
          </Box>
        </Box>
      </Grid>

      <Dialog fullScreen open={openDialog} onClose={() => setOpenDialog(false)}>
        <Box sx={{ m: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6">IN 1</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <RadioGroup
              value={selectedCableControlMode}
              onChange={handleRadioChange}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    md: "repeat(2, 1fr)",
                  },
                  mb: 3,
                }}
              >
                {getCableControlModeEnumValues().map((v) => {
                  return (
                    <Fragment key={`cm_${v}`}>
                      <CustomImageRadio
                        value={v}
                        checked={+v === selectedCableControlMode}
                        imageName={`control_mode${v}.svg`}
                        label={mapCableControlModeValueToLabel(+v)}
                      />
                    </Fragment>
                  );
                })}
              </Box>
            </RadioGroup>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button variant="contained" onClick={() => setOpenDialog(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export { ControlBoxMode };
